import { Epic } from "redux-observable";
import { from, of } from "rxjs";
import {
  filter,
  switchMap,
  map,
  catchError,
  debounceTime
} from "rxjs/operators";
import { isActionOf } from "typesafe-actions";
import { RootAction } from "../../store/rootAction";
import { RootState } from "../../store/rootReducer";
import { ApiClient } from "../../lib/api";
import { fetchQuoteAsync, createOrderAsync } from "./actions";

export const fetchQuoteEpic: Epic<
  RootAction,
  RootAction,
  RootState,
  ApiClient
> = (action$, state$, client) =>
  action$.pipe(
    filter(isActionOf(fetchQuoteAsync.request)),
    debounceTime(300),
    switchMap(action =>
      from(client.getQuote(action.payload)).pipe(
        map(fetchQuoteAsync.success),
        catchError((error: Error) => of(fetchQuoteAsync.failure(error)))
      )
    )
  );

export const createOrderEpic: Epic<
  RootAction,
  RootAction,
  RootState,
  ApiClient
> = (action$, state$, client) =>
  action$.pipe(
    filter(isActionOf(createOrderAsync.request)),
    switchMap(action =>
      from(client.createOrder(action.payload)).pipe(
        map(createOrderAsync.success),
        catchError((error: Error) => of(createOrderAsync.failure(error)))
      )
    )
  );
